export default __webpack_public_path__ + "static/media/hachshara.44939cb9.svg";